var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Confetti",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M0,0H50V50H0Z",
    fill: "none",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M4,5H8.167",
    transform: "translate(4.333 5.417)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M5,4V8.167",
    transform: "translate(5.417 4.333)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12.042,4,11,8.167",
    transform: "translate(11.917 4.333)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M18,5h4.167",
    transform: "translate(19.5 5.417)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M19,4V8.167",
    transform: "translate(20.583 4.333)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M16.083,9,14,11.083",
    transform: "translate(15.167 9.75)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M18,13.542,22.167,12.5",
    transform: "translate(19.5 13.542)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M18,19h4.167",
    transform: "translate(19.5 20.583)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M19,18v4.167",
    transform: "translate(20.583 19.5)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.919,23.579,12.339,10,3.194,29.958a2.083,2.083,0,0,0,2.769,2.769l19.956-9.146Z",
    transform: "translate(3.248 10.833)",
    fill: "none",
    stroke: "auto",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/Confetti.672c3f0b8ace56f3074f313cc7f8056b.svg";
export { ForwardRef as ReactComponent };